const normalizeEmail = (email: string | null | undefined): string | null => {
  if (!email) return null;
  const normalized = email.trim().toLowerCase();
  return normalized || null;
};

export type PrivateAlphaFeature =
  | 'trade_log'
  | 'market_context'
  | 'fed_watch'
  | 'themes'
  | 'weekend_movers';

const PRIVATE_ALPHA_EMAIL_ALLOWLISTS: Record<PrivateAlphaFeature, Set<string>> = {
  trade_log: new Set(['amelwani9@gmail.com']),
  market_context: new Set(['amelwani9@gmail.com']),
  fed_watch: new Set(['amelwani9@gmail.com']),
  themes: new Set([
    'amelwani9@gmail.com',
    'altrionaethar@proton.me',
    'cherylmelvy@gmail.com',
    'vaswanidhiren@gmail.com',
    'dvaswani@quantchecklabs.com',
  ]),
  weekend_movers: new Set(['amelwani9@gmail.com', 'altrionaethar@proton.me']),
};

export const canAccessPrivateAlphaFeature = (
  email: string | null | undefined,
  feature: PrivateAlphaFeature
): boolean => {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  return PRIVATE_ALPHA_EMAIL_ALLOWLISTS[feature].has(normalized);
};

export const canAccessTradeLogFeature = (email: string | null | undefined): boolean =>
  canAccessPrivateAlphaFeature(email, 'trade_log');

export const canAccessMarketContextFeature = (email: string | null | undefined): boolean =>
  canAccessPrivateAlphaFeature(email, 'market_context');

export const canAccessFedWatchFeature = (email: string | null | undefined): boolean =>
  canAccessPrivateAlphaFeature(email, 'fed_watch');

export const canAccessThemesFeature = (email: string | null | undefined): boolean =>
  canAccessPrivateAlphaFeature(email, 'themes');

export const canAccessWeekendMoversFeature = (email: string | null | undefined): boolean =>
  canAccessPrivateAlphaFeature(email, 'weekend_movers');
